import type {
  PropsWithChildren,
} from 'react';
import Alerts from '@/components/Alerts';

import '@/stylesheets/global.css';
import '@/stylesheets/scrollbar.module.css';

const RootLayout = (props: PropsWithChildren) => {
  // ##########################################################################
  // PROPS
  // ##########################################################################

  const {
    children,
  } = props;

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <div className="root-layout">
      <Alerts />

      {children}
    </div>
  );
};

export default RootLayout;
